import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    maxWidth: 564,
    marginTop: 40,
  },
  upperSectionContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  sectionDivider: {
    height: 2,
    width: "100%",
    backgroundColor: theme.palette.natural.t8,
    marginTop: 8,
    marginBottom: 8,
  },
  indicatorTextContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  indicatorText: {
    fontSize: 14,
    color: theme.palette.natural.t1,
    marginRight: 8,
  },
  italicIndicatorText: {
    fontSize: 14,
    color: theme.palette.natural.t1,
    marginRight: 8,
    fontStyle: "italic",
  },
  mainText: {
    fontSize: 16,
    fontWeight: "bold",
    color: theme.palette.natural.t1,
  },
  secondaryText: {
    fontSize: 14,
    color: theme.palette.natural.t1,
  },
}));
